import React from 'react';

const Modal = (props) => {

  let ref;

  const processClick = (e) => {
    e.stopPropagation();

    if(e.target !== ref) return;
    props.onClick();
  }

  const modalStyles = {
    display: (props.show ? 'block' :'none'),
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    overflow: 'hidden',
    zIndex: 1500,
    ...props.style
  }

  return (
    <div ref={(modal) => {ref = modal}} style={modalStyles} className={props.className} onClick={processClick}>
      {props.children}
    </div>
  );
}

Modal.defaultProps = {
  onClick: () => {}
};

export default Modal;